export default __webpack_public_path__ + "static/media/twitter.ac440859.svg";